import React from 'react';

export const readOnlyContext = React.createContext(false);

type ReadOnlyProviderProps = {
   value: boolean;
   children: React.ReactNode;
};

export const ReadOnlyProvider = ({value, children}: ReadOnlyProviderProps) => {
   const {Provider} = readOnlyContext;
   return <Provider value={value}>{children}</Provider>;
};
